<!-- Upload status section -->
@if (visibleUploads().length > 0) {
  <div class="mb-4 space-y-2">
    @for (upload of visibleUploads(); track upload.id) {
      @if (upload.status === UploadStatus.Started) {
        <div
          class="bg-proffeo-feedback-info-surface border border-proffeo-feedback-info-border rounded-lg p-3 flex items-center gap-3"
        >
          <div class="flex-1">
            <p class="text-sm text-proffeo-info">{{ upload.fileName }}</p>
            @if (upload.progress === undefined) {
              <mat-progress-bar
                mode="indeterminate"
                class="mt-1"
              />
            } @else {
              <mat-progress-bar
                [value]="upload.progress"
                mode="determinate"
                class="mt-1"
              />
            }
          </div>
          @if (upload.progress !== undefined) {
            <span class="text-xs text-proffeo-info">{{ upload.progress }}%</span>
          }
          <proffeo-ui-button
            (clicked)="onCancel(upload.id)"
            variant="ghost"
            size="sm"
            text="common.cancel"
          />
        </div>
      }
      @if (upload.status === UploadStatus.Failure) {
        <div
          class="bg-proffeo-danger/20 border border-proffeo-danger/40 rounded-lg p-3 flex items-center justify-between"
        >
          <div class="flex-1">
            <p class="text-sm text-proffeo-danger">{{ upload.fileName }}</p>
            <p class="text-xs text-proffeo-danger mt-1">{{ upload.error }}</p>
          </div>
          <proffeo-ui-button
            (clicked)="onDismiss(upload.id)"
            variant="ghost"
            size="sm"
            fontIcon="close"
            ariaLabel="close"
          />
        </div>
      }
      @if (upload.status === UploadStatus.Canceled) {
        <div class="flex items-center justify-between gap-3 p-3">
          <div>
            <p>{{ upload.fileName }}</p>
            <p>{{ 'files.upload-canceled' | translate }}</p>
          </div>
          <proffeo-ui-button
            (clicked)="onDismiss(upload.id)"
            variant="ghost"
            size="sm"
            fontIcon="close"
            ariaLabel="close"
          />
        </div>
      }
    }
  </div>
}
